import { motion } from "framer-motion";
import { MaskLine } from "@/components/Reveal";

const LABEL_FADE = { initial: { opacity: 0 }, animate: { opacity: 1 }, transition: { duration: 0.8, delay: 0.1 } };
const TEXT_RISE = { initial: { opacity: 0, y: 16 }, animate: { opacity: 1, y: 0 }, transition: { duration: 0.9, delay: 0.55, ease: "easeInOut" } };

export const PageHeader = ({ number, label, title, accent, text, testid }) => (
    <section data-testid={testid} className="relative overflow-hidden pb-14 pt-32 lg:pb-20 lg:pt-44">
        <span aria-hidden className="pointer-events-none absolute -right-6 -top-8 select-none font-serif text-[12rem] italic leading-none text-wood/[0.04] lg:text-[22rem]">
            {number}
        </span>
        <div className="relative mx-auto max-w-7xl px-6 sm:px-12 lg:px-20">
            <motion.p {...LABEL_FADE} className="mb-8 flex items-center gap-4 text-xs uppercase tracking-[0.3em] text-timber">
                <span className="h-px w-10 bg-terra/60" />
                {label}
            </motion.p>
            <h1 className="max-w-4xl font-serif text-4xl font-light leading-[1.08] tracking-tight text-ink sm:text-5xl lg:text-6xl">
                <MaskLine delay={0.15}>{title}</MaskLine>
                {accent && (
                    <MaskLine delay={0.3}>
                        <em className="font-normal text-terra">{accent}</em>
                    </MaskLine>
                )}
            </h1>
            {text && (
                <motion.p {...TEXT_RISE} className="mt-8 max-w-xl text-base font-light leading-relaxed text-mute sm:text-lg">
                    {text}
                </motion.p>
            )}
        </div>
    </section>
);
